import {
  Avatar,
  Box,
  Button,
  Circle,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  ScaleFade,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { AiFillStar, AiOutlineShoppingCart } from "react-icons/ai";
import { FiThumbsUp } from "react-icons/fi";
import {
  IoIosClose,
  IoIosContact,
  IoIosListBox,
  IoIosSearch,
  IoLogoWhatsapp,
  IoMdChatboxes,
  IoMdThumbsDown,
  IoMdThumbsUp,
} from "react-icons/io";
import { IoMenuOutline } from "react-icons/io5";

import { VscSend } from "react-icons/vsc";

import EmojiPicker from "emoji-picker-react";

import { CloseIcon } from "@chakra-ui/icons";
import { socket } from "../../client/wss";
import appstore from "../../store/appStore";
import { DataShow } from "./DataShow";
import { ShowTyping } from "./ShowTyping";
import ReactMarkdown from 'react-markdown';
export const ChatMenu = ({
  conversationStart,
  isMobile,
  botDetails,
  currentChatPanelview,
  transformedData,
  botOpen,
  openChatBot,
  setTrackOrderSearched,
  setIsContactUsMsgSend,
  setCurrentChatPanelview,
  scrolled,
  isColorDark,
  messagesContainerRef,
  showTyping,
  openCart,
  suggestions,
  onSuggestionSelected,
  isAskingRating,
  showEndConv,
  setAskingRating,
  sendMessageToBot,
  userMessage,
  setUserMessage,
  setShowPicker,
  showPicker,
  onEmojiClick,
  setRating,
  rating,
  handleSubmitReview,
  isAskii
}) => {
  const [showAttachmentPopover, setShowAttachmentPopover] = useState(false); // Initialize the state for file attachment popover
  const { setMessages, setShowTyping } = appstore();
  const [showTool, setShowTool] = useState(false);
  const [showIcons, setShowIcons] = useState(false);
  const [full, setFull] = useState(false);
  // Reference for file input
  const fileInputRef = useRef(null);

  // Function to handle file selection
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    // Handle the file, such as uploading or previewing it
    // console.log("Selected file:", file);
    // Add your file handling logic here (upload, preview, etc.)
  };
// console.log(suggestions,"===============> suggestions")
  const firstChunks = ['{"', "message", '":"'];
  const lastChunks = [`"`, "greetings", ":  "];
  const [isLastChunkCompleted, setIsLastChunkCompleted] = useState(false);
  const [currentResponse, setCurrentResponse] = useState(""); // Current incomplete assistant response
  const isLastChunkCompletedRef = useRef(isLastChunkCompleted); // Create a ref for isLastChunkCompleted
  let extractedContent = "";
  // console.log("currentResponse", currentResponse);
  useEffect(() => {
    // Handle incoming messages from the server
    const isFirstChunk = (chunk) =>
      firstChunks.some((firstChunk) => chunk.startsWith(firstChunk));

    // Check if the content ends with any of the predefined last chunks
    const isLastChunk = (content) => {
      const greetingsChunkDetected = content.includes('","greetings":');
      // console.log(`isLastChunk: ${content} boolean ${greetingsChunkDetected}`);
      const lastChunkData = lastChunks.some((lastChunk) =>
        content.endsWith(lastChunk)
      );
      setIsLastChunkCompleted(greetingsChunkDetected || lastChunkData); // Update the state
      isLastChunkCompletedRef.current = greetingsChunkDetected || lastChunkData;
      return greetingsChunkDetected || lastChunkData;
    };
    socket.on("message-received-chunk", (data) => {
      // console.log("message-received-chunk");
      const newMessage = JSON.parse(data);
      // console.log("newMessage111", newMessage);

      if (newMessage.role === "assistant" && !newMessage.isComplete) {
        const contentChunk = newMessage.content;
        // console.log("contentChunk", contentChunk);

        // Handle incomplete message chunks
        // console.log(
        //   "isLastChunkCompleted ref",
        //   isLastChunkCompletedRef.current
        // );
        if (!isLastChunkCompletedRef.current) {
          setShowTyping(false);
          // console.log("line 47:", extractedContent);
          if (!isFirstChunk(contentChunk)) {
            // extractedContent += contentChunk;
            // console.log("line 51 contentChunk:");
            // setCurrentResponse((prev) => prev + contentChunk);
            // Update UI with the ongoing response
          }
          if (isLastChunk(extractedContent)) {
            // extractedContent = extractedContent.slice(0, -lastChunks.length); // Remove last chunk from content
            // console.log("extractedContent", extractedContent);

            // setMessages((prevMessages) => [
            //   ...prevMessages,
            //   { role: "assistant", content: extractedContent.split('","')[0] },
            // ]);
            const currentTime = new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            });
            // setMessages(extractedContent.split('","')[0], false, currentTime);
            // Reset the assembled message
            // setCurrentResponse("");
            setIsLastChunkCompleted(false); // Reset chunk completion flag
          }
        }
      } else {
        // Handle user messages and other messages
        isLastChunkCompletedRef.current = false;
        extractedContent = "";
        // setMessages((prevMessages) => [...prevMessages, newMessage]);
      }
    });
    socket.on("message-received-chunk-new", (data) => {
      // isLastChunkCompletedRef.current = true;
      setShowTyping(false);

      extractedContent += data;
      setCurrentResponse((prev) => (prev + data));
      // console.log("daSDFSDFSDFSFFta", data);
      // console.log("extractedContent", extractedContent);
    });
    socket.on("message-received-chunk-new-completed", (data) => {
      // let dataNew = JSON.parse(data);
      // console.log("dataNew", extractedContent);
      // console.log("currentResponse", currentResponse);

      isLastChunkCompletedRef.current = false;
      const currentTime = new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      setMessages(
        extractedContent.replace(/\\n/g, '\n'),
        false,
        currentTime
      );
      extractedContent = "";
      setCurrentResponse("");
      setIsLastChunkCompleted(false);
    });
    return () => {
      socket.off("message-received-chunk");
      socket.off("message-received-chunk-new");
      socket.off("message-received-chunk-new-completed");
    };
  }, [socket]);

  // console.log(transformedData,"========================> tranformed data")
  return (
    <>
      {currentChatPanelview == "conversation" && (
        <>
          <Box
            className="chatbotHeaderMenu"
            height={scrolled && !full > 0 ? "18%" : "18%"}
            position="relative"
            style={{
              border: "1px solid g",
              boxShadow: "0px 3px 5px -2px rgba(0,0,0,0.75)",
              transition: "height 0.5s ease-in-out",

              zIndex: 50,
            }}
            bg={botDetails.accentColor}
          >
            {/* Close Button */}
            <Box
              position="absolute"
              top="35%" // Vertically center the icons
              left="50%" // Horizontally center the icons
              transform="translate(-50%, -50%)" // Truly center the icons
              display="flex"
              zIndex={99999999}
              justifyContent="space-between" // Space out the icons
              width="90%" // Adjust this width to create spacing between icons
            >
              {!isAskii&&<CloseIcon
             position="absolute"
             right={0}
             top={0}
             color={isColorDark(botDetails.accentColor) ? "white" : "black"}
             onClick={() => {
               window.parent.postMessage({ type: "botOpen", botOpen: false }, "*");
               openChatBot();
             }}
             zIndex={2}
             size="sm"
             cursor="pointer"
             transition="transform 0.3s ease-in-out" // Smooth rotation effect
             _hover={{ transform: "rotate(180deg)" }}
              />}
            </Box>
            {/* Log, Header, and Subheader */}

            <Box
  position="absolute"
  top="50%"
  left="50%"
  transform="translate(-50%, -50%)"
  display="flex"
  flexDirection="column"
  justifyContent="center"
  alignItems="center"
  width="100%"
>
  <div>
    <h2
      size="sm"
      mb={1}
      className="bounce-text"
      style={{
        fontWeight: "bold",
        margin: 0,
        fontSize: "1.5rem",
        color: isColorDark(botDetails.accentColor) ? "white" : "black",
        display: "inline-block",
      }}
    >
      {botDetails.botName.split("").map((char, index) => (
        <span key={index} className="bounce-letter" style={{ animationDelay: `${index * 0.1}s` }}>
          {char}
        </span>
      ))}
    </h2>
  </div>
</Box>

<style>
  {`
    @keyframes bounce {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
    }

    .bounce-text:hover .bounce-letter {
      display: inline-block;
      animation: bounce 0.5s ease-in-out;
    }
  `}
</style>


            {/* Dot at the top-left that will trigger the Popover */}
            <Box
              position="absolute"
              top="29%" // Vertically center the icons
              left="50%" // Horizontally center the icons
              transform="translate(-50%, -50%)" // Truly center the icons
              display="flex"
              justifyContent="space-between" // Space out the icons
              width="90%" // Adjust this width to create spacing between icons
            >
              <Popover>
                <PopoverTrigger>
                  <Circle
                    position="absolute"
                    top={0}
                    cursor="pointer" // Make the circle clickable
                  >
                    <IoMenuOutline
                      size={"25px"}
                      color={
                        isColorDark(botDetails?.accentColor) ? "white" : "black"
                      }
                    />
                  </Circle>
                </PopoverTrigger>

                <PopoverContent style={{ width: "180px" }}>
                  <PopoverArrow />
                  <PopoverBody style={{ paddingTop: "12px" }}>
                    {/* First clickable icon + text */}
                    {botDetails.menuSection.conversation && (
                      <Button
                        onClick={() => {
                          setTrackOrderSearched({
                            isSearched: false,
                            notFound: false,
                            detail: {
                              status: "",
                              orderNo: "",
                              trackLink: "",
                              subTotal: "",
                            },
                            inputDetails: {
                              orderNo: "",
                              phoneOrEmail: "",
                            },
                          });
                          setIsContactUsMsgSend({
                            isSend: false,
                            inputDetails: {
                              fullName: "",
                              email: "",
                              msg: "",
                            },
                          });
                          conversationStart.isStart
                            ? setCurrentChatPanelview("conversation")
                            : setCurrentChatPanelview("Home");
                        }}
                        leftIcon={<IoMdChatboxes style={{ color: "black" }} />}
                        style={{
                          background:
                            currentChatPanelview == "Home" ||
                            currentChatPanelview == "conversation"
                              ? "#E2E8F0"
                              : "white",
                          color: "black",
                          width: "100%",
                          justifyContent: "flex-start",
                        }}
                        fontSize="14.82px"
                      >
                        Conversations
                      </Button>
                    )}
                    {/* Second clickable icon + text */}
                    {botDetails.menuSection.whatsapp && (
                      <Button
                        leftIcon={<IoLogoWhatsapp style={{ color: "black" }} />}
                        onClick={() => {
                          setTrackOrderSearched({
                            isSearched: false,
                            notFound: false,
                            detail: {
                              status: "",
                              orderNo: "",
                              trackLink: "",
                              subTotal: "",
                            },
                            inputDetails: {
                              orderNo: "",
                              phoneOrEmail: "",
                            },
                          });
                          setIsContactUsMsgSend({
                            isSend: false,
                            inputDetails: {
                              fullName: "",
                              email: "",
                              msg: "",
                            },
                          });
                          window.open(
                            botDetails?.whatsappRedirectLink,
                            "_blank"
                          );
                        }}
                        style={{
                          background: "white",
                          color: "black",
                          width: "100%",
                          justifyContent: "flex-start",
                        }}
                        fontSize="14.82px"
                      >
                        Whatsapp
                      </Button>
                    )}

                    {botDetails.menuSection.trackOrder && (
                      <Button
                        leftIcon={<IoIosListBox style={{ color: "black" }} />}
                        onClick={() => {
                          setTrackOrderSearched({
                            isSearched: false,
                            notFound: false,
                            detail: {
                              status: "",
                              orderNo: "",
                              trackLink: "",
                              subTotal: "",
                            },
                            inputDetails: {
                              orderNo: "",
                              phoneOrEmail: "",
                            },
                          });
                          setIsContactUsMsgSend({
                            isSend: false,
                            inputDetails: {
                              fullName: "",
                              email: "",
                              msg: "",
                            },
                          });
                          setCurrentChatPanelview("trackOrder");
                        }}
                        style={{
                          background: "white",
                          color: "black",
                          width: "100%",
                          justifyContent: "flex-start",
                        }}
                        fontSize="14.82px"
                      >
                        TrackOrder
                      </Button>
                    )}

                    {botDetails.menuSection.contactUs && (
                      <Button
                        leftIcon={<IoIosContact style={{ color: "black" }} />}
                        onClick={() => {
                          setTrackOrderSearched({
                            isSearched: false,
                            notFound: false,
                            detail: {
                              status: "",
                              orderNo: "",
                              trackLink: "",
                              subTotal: "",
                            },
                            inputDetails: {
                              orderNo: "",
                              phoneOrEmail: "",
                            },
                          });
                          setCurrentChatPanelview("contactUs");
                        }}
                        style={{
                          background: "white",
                          color: "black",
                          width: "100%",
                          justifyContent: "flex-start",
                        }}
                        fontSize="14.82px"
                      >
                        Contact Us
                      </Button>
                    )}
                    <Button
                      leftIcon={<AiOutlineShoppingCart />}
                      onClick={openCart}
                      fontSize="14.82px"
                      style={{
                        background: "white",
                        color: "black",
                        width: "100%",
                        justifyContent: "flex-start",
                      }}
                    >
                      Cart
                    </Button>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </Box>
            {/* Optional: You can add more content in the Box */}
          </Box>

          {botDetails?.menuSection?.search && (
            <Box
              className="menu-buttons"
              display={"flex"}
              m={"2%"}
              bg={"#f4f4f6"}
              py={"15px"}
              pl="10px"
              pr="3px"
              h={"45px"}
              fontSize={"13px"}
              alignItems={"center"}
              borderRadius={"10px"}
              justifyContent={"flex-start"}
            >
              {" "}
              <Box display={"flex"} alignItems={"center"} gap={"8px"}>
                {" "}
                <IoIosSearch /> Search for products ...
              </Box>
            </Box>
          )}

          <Box
            bg={"white"}
            // h={"360px"}
            // borderBottomRadius={"18px"}
            // onScroll={() => {
            //     const element = messagesContainerRef.current;
            //     const atBottom =
            //       element.scrollHeight - element.scrollTop === element.clientHeight;
            //       // console.log(atBottom,"=============> dkdff")
            //   console.log(scrolled,"======>","cliked")
            //   setFull(false);
            // }}
            display={"grid"}
            alignContent={"space-between"}
            ref={messagesContainerRef}
            h={isMobile ? "80%" : "100vh"}
            overflowX={"hidden"}
            className="chat-bot-text-display-container"
          >
            <Box
              p={"20px"}
              pb={"12px"}
              // overflowY={"scroll"}

              id="ul-content-box"
              display={"flex"}
              flexDirection={"column"}

              // border={"1px solid red"}
            >
              <Box mb={"12px"} width={"fit-content"}>
                <Box display={"flex"} gap={"10px"}>
                  <Avatar
                    src={
                      botDetails.companyLogo ||
                      "https://e7.pngegg.com/pngimages/178/595/png-clipart-user-profile-computer-icons-login-user-avatars-monochrome-black.png"
                    }
                    name="Company"
                    size="sm"
                  />
                  <Text
                    fontSize={"14px"}
                    fontWeight={"400"}
                    p={"8px"}
                    borderRadius={"6px"}
                    style={{ color: "black", background: "#F3F4F6" }}
                  >
                    {botDetails.welcomeMessage}
                  </Text>
                </Box>
                <p className="timestamp" style={{ textAlign: "right" }}>
                  {new Date().toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </p>
              </Box>

              <DataShow
                transformedData={transformedData}
                botDetails={botDetails}
              />

              {showTyping ? <ShowTyping botDetails={botDetails} /> : ""}
              {currentResponse.length ? (
                <Box>
                  <Box display={"flex"} mb={"12px"} gap={"10px"}>
                    <Image
                      src={
                        botDetails.companyLogo ||
                        "https://e7.pngegg.com/pngimages/178/595/png-clipart-user-profile-computer-icons-login-user-avatars-monochrome-black.png"
                      }
                      w={"28px"}
                      h={"30px"}
                      borderRadius={"100px"}
                    />
                    <Box
                      fontSize={"14px"}
                      style={{ background: "#F3F4F6" }}
                      fontWeight={"400"}
                      p={"8px"}
                      borderRadius={"6px"}
                      stye={{ whiteSpace: "pre-wrap" }}
                    >
                      <ReactMarkdown>{currentResponse.replace(/\\n/g, '\n')}</ReactMarkdown>
                    </Box>
                  </Box>
                </Box>
              ) : (
                ""
              )}
              {appstore.getState().showSuggestions &&
              !showTyping &&
              suggestions &&
              suggestions.length !== 0 ? (
                <Box
                  className="suggestion-box"
                  style={{
                    width: "100%",
                    display: "flex",
                    // Spaces out the boxes equally
                    justifyContent: "space-evenly",
                    flexWrap: "wrap", // Allows wrapping of suggestions into new rows
                    gap: "2px", // Space between items
                  }}
                >
                  {suggestions.map((suggestion, id) => {
                    return (
                      <ScaleFade
                        initialScale={0.5}
                        in={true}
                        autoFocus
                        key={id}
                      >
                        <Box
                          fontSize={"14px"}
                          marginTop={"5px"}
                          fontWeight={"400"}
                          boxShadow="rgba(28, 28, 28, 0.2) 0px 5px 12px -3px"
                          p={"8px"}
                          borderRadius={"6px"}
                          style={{
                            cursor: "pointer",
                            whiteSpace: "pre-wrap",
                            border: `1px solid ${botDetails.accentColor}`,
                            color: "black",
                            background: "#F3F4F6",
                            transition: "all 0.3s ease",
                          }}
                          onClick={() => onSuggestionSelected(suggestion)}
                          _hover={{
                            border: `1px solid ${botDetails.accentColor}`,
                            background: "white",
                            color: isColorDark(botDetails?.accentColor)
                              ? botDetails?.accentColor
                              : "black",
                          }}
                        >
                          {suggestion}
                        </Box>
                      </ScaleFade>
                    );
                  })}
                </Box>
              ) : (
                ""
              )}
            </Box>
          </Box>
          <>
            {!isAskingRating ? (
              <>
                <Box
                  w={"100%"}
                  display={"flex"}
                  // style={{border:"1px solid black"}}
                  justifyContent={"center"}
                  background={"white"}
                  zIndex={50}
                  className="chatbotSendInput"
                >
                  <Box p={"4px"} w={"100%"}>
                    <form
                      action=""
                      onSubmit={sendMessageToBot}
                      className="chatbotSendInputForm"
                    >
                      <InputGroup
                        borderRadius={"6px"}
                        border={
                          isColorDark(botDetails?.accentColor)
                            ? `0.5px solid ${botDetails.accentColor}`
                            : `0.5px solid black`
                        }
                        boxShadow="rgba(28, 28, 28, 0.2) 0px 5px 12px -3px"
                        outline={"none"}
                        style={{ padding: "1% !important" }}
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Input
                            placeholder={botDetails.inputPlaceholder}
                            value={userMessage}
                            style={{
                              touchAction: "manipulation",
                              fontSize: "16px",
                              background: "white",
                              color: "black",
                              height: "40px",
                              width: "80%",
                              outline: "none",
                              border: "none",
                              marginLeft: 4,
                            }}
                            onChange={(e) => {
                              setUserMessage(e.target.value);
                              appstore.getState().setShowSuggestions(false);
                            }}
                            _focusVisible={true}
                          />
                        </div>
                        <InputLeftElement
                          style={{
                            width: "fit-content",
                            height: "100%",
                            display: "flex", // Ensure the items are displayed flexibly
                            alignItems: "center", // Align vertically in the middle
                            justifyContent: "center", // Space out the children
                          }}
                        >
                          <div>
                            <Box
                              width={"40px"}
                              height={"40px"}
                              // bg={"red"}
                              position={"absolute"}
                              top={-10}
                              left={0}
                            >
                              {showIcons && (
                                <div
                                  style={{
                                    right: showIcons ? 60 : -120,

                                    zIndex: 3,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-around",
                                    width: "60px",

                                    // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Add shadow for visibility
                                    transition: "right 0.3s ease-in-out",
                                  }}
                                  onMouseLeave={() => setShowIcons(false)}
                                >
                                  <IoMdThumbsUp
                                    size={"25px"}
                                    color={"green"}
                                    style={{
                                      marginRight: 2,
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.transform = "scale(1.1)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.transform = "scale(1)")
                                    }
                                    onClick={() => {
                                      setAskingRating(true);
                                    }}
                                  />
                                  <IoMdThumbsDown
                                    size={"25px"}
                                    color={"red"}
                                    style={{
                                      marginRight: 2,
                                      cursor: "pointer",
                                      padding: 2,
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.transform = "scale(1.1)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.transform = "scale(1)")
                                    }
                                    onClick={() => {
                                      setAskingRating(true);
                                    }}
                                  />
                                </div>
                              )}
                            </Box>
                            {showTool && !showIcons && (
                              <Box
                                width="auto"
                                style={{
                                  whiteSpace: "nowrap",
                                  background: "rgba(0, 0, 0, 0.8)", // Black background with opacity
                                  color: "white",
                                  fontSize: "12px", // Smaller font size
                                  padding: "4px 8px", // Padding for a tooltip-like appearance
                                  borderRadius: "4px", // Rounded corners
                                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)", // Subtle shadow for depth
                                }}
                                position="absolute"
                                top={-10}
                                left={0}
                              >
                                <p style={{ margin: 0 }}>End Conversation</p>
                              </Box>
                            )}
                            <div
                              style={{
                                position: "relative",
                                width: "20px",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden",
                                cursor: "pointer",
                                marginRight: 2,
                              }}
                              onClick={() => {
                                if (!showIcons) setShowIcons(true);
                                else setShowIcons(false);
                              }}
                            >
                              {/* Thumbs Up Div */}

                              <FiThumbsUp
                                style={{ marginLeft: 2, color: "black" }}
                                onMouseEnter={() => setShowTool(true)}
                                onMouseLeave={() => setShowTool(false)}
                                size={"20px"}
                              />
                            </div>
                          </div>

                          <Popover
                            isOpen={showPicker}
                            onClose={() => setShowPicker(false)}
                            isLazy={true}
                            closeOnBlur={false}
                          >
                            <PopoverTrigger>
                              <img
                                style={{ width: "20px", cursor: "pointer" }}
                                className="emoji-icon"
                                src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
                                onClick={() => setShowPicker((val) => !val)}
                              />
                            </PopoverTrigger>
                            <PopoverContent
                              width={"auto"}
                              maxWidth={"320px"}
                              p={0}
                              onMouseEnter={() => setShowPicker(true)}
                              onMouseLeave={() => setShowPicker(false)}
                            >
                              <PopoverArrow />
                              <PopoverCloseButton />
                              <Box>
                                <EmojiPicker
                                  style={{ background: "white" }}
                                  height={"350px"}
                                  emojiStyle="google"
                                  width={"100%"}
                                  onEmojiClick={onEmojiClick}
                                />
                              </Box>
                            </PopoverContent>
                          </Popover>
                        </InputLeftElement>
                        <InputRightElement
                          style={{
                            // boder: "1px solid red",
                            width: "fit-content",
                            height: "100%",
                            display: "flex", // Ensure the items are displayed flexibly
                            alignItems: "center", // Align vertically in the middle
                            justifyContent: "left", // Space out the children
                          }}
                        >
                          {/* Send button */}
                          {userMessage.length == 0 ? (
                            <div
                              style={{
                                width: "30px",
                                height: "30px",

                                borderRadius: "6px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {" "}
                              <VscSend
                                fontSize={"20px"}
                                cursor={"pointer"}
                                color={"gray"}
                              />
                            </div>
                          ) : (
                            <div stye={{ padding: 4, marginRight: 2 }}>
                              <div
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  background: botDetails.accentColor,
                                  borderRadius: "6px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  boxShadow:
                                    "rgba(28, 28, 28, 0.2) 0px 5px 12px -3px",
                                }}
                              >
                                <VscSend
                                  fontSize={"20px"}
                                  cursor={"pointer"}
                                  color={
                                    isColorDark(botDetails.accentColor)
                                      ? "white"
                                      : "black"
                                  }
                                  onClick={(e) => {
                                    sendMessageToBot();
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </InputRightElement>
                      </InputGroup>
                    </form>
                  </Box>
                  {/* {showEndConv && (
                    <Button
                      h={"25px"}
                      padding={"10px"}
                      bg={botDetails.accentColor}
                      border={`1px solid ${botDetails.accentColor}`}
                      color={
                        isColorDark(botDetails?.accentColor) ? "white" : "black"
                      }
                      boxShadow="md"
                      _hover={{
                        border: `1px solid ${botDetails.accentColor}`,
                        bg: `white`,
                        color: isColorDark(botDetails?.accentColor)
                          ? botDetails?.accentColor
                          : "black",
                      }}
                      size="md"
                      fontWeight={"400"}
                      fontSize={"15px"}
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      borderRadius={"10px"}
                      cursor={"pointer"}
                      onClick={() => {
                        setAskingRating(true);
                      }}
                    >
                      End Conversation
                    </Button>
                  )} */}
                </Box>
              </>
            ) : (
              <Box
                h={"33%"}
                bg="white"
                position={"absolute"}
                bottom={0}
                w={"100%"}
                opacity={"0.9"}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                gap={"10px"}
                style={{
                  boxShadow: "rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset",
                }}
              >
                <Box display={"flex"} w={"100%"} justifyContent={"flex-end"}>
                  <IoIosClose
                    fontSize={"35px"}
                    cursor="pointer"
                    position="absolute"
                    left="0"
                    onClick={openChatBot}
                  />{" "}
                </Box>
                <Text
                  fontSize={"18px"}
                  fontWeight={"400"}
                  color={"black"}
                  textAlign={"center"}
                >
                  How did you find your experience with our chat?
                </Text>
                <Box display={"flex"} alignItems={"center"}>
                  <AiFillStar
                    onClick={() => {
                      setRating(1);
                    }}
                    fontSize={`${rating >= 1 ? "34px" : "28px"}`}
                    style={{ color: rating >= 1 ? "#ffb851" : "black" }}
                  />
                  <AiFillStar
                    onClick={() => {
                      setRating(2);
                    }}
                    fontSize={`${rating >= 2 ? "34px" : "28px"}`}
                    style={{ color: rating >= 2 ? "#ffb851" : "black" }}
                  />
                  <AiFillStar
                    onClick={() => {
                      setRating(3);
                    }}
                    fontSize={`${rating >= 3 ? "34px" : "28px"}`}
                    style={{ color: rating >= 3 ? "#ffb851" : "black" }}
                  />
                  <AiFillStar
                    onClick={() => {
                      setRating(4);
                    }}
                    fontSize={`${rating >= 4 ? "34px" : "28px"}`}
                    style={{ color: rating >= 4 ? "#ffb851" : "black" }}
                  />
                  <AiFillStar
                    onClick={() => {
                      setRating(5);
                    }}
                    fontSize={`${rating >= 5 ? "34px" : "28px"}`}
                    style={{ color: rating >= 5 ? "#ffb851" : "black" }}
                  />
                </Box>
                {rating >= 1 && (
                  <Box
                    h={"25px"}
                    padding={"10px"}
                    style={{
                      background: botDetails.accentColor,
                      color: isColorDark(botDetails?.accentColor)
                        ? "white"
                        : "black",
                      border: isColorDark(botDetails?.accentColor)
                        ? botDetails?.accentColor
                        : "black",
                    }}
                    _hover={{
                      border: `1px solid ${botDetails.accentColor}`,
                      bg: "white",
                      color: isColorDark(botDetails?.accentColor)
                        ? `${botDetails.accentColor}`
                        : "black",
                    }}
                    fontWeight={"500"}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    borderRadius={"10px"}
                    cursor={"pointer"}
                    onClick={handleSubmitReview}
                  >
                    Submit
                  </Box>
                )}
              </Box>
            )}
          </>
        </>
      )}
    </>
  );
};
